import styled from '@emotion/styled'
import { Button } from 'antd'

export const CommonButton = styled(Button)<{ active?: boolean }>(
  ({ active = true }) => `
  background-color: ${active ? 'transparent' : '#4A4A68'};
  color: ${active ? '#4A4A68' : '#FFFFFF'};
  border-color: #4a4a68;

  justify-content: center;

  &:hover,
  &:focus,
  &:active {
    background-color: ${active ? 'transparent' : '#4A4A68'};
    color: ${active ? '#4A4A68' : '#FFFFFF'};
    border-color: #4a4a68;
  }
`
)
